import axios from '@axios'

const route = 'register/service'

export default {
  namespaced: true,
  state: {
    services: [],
    categoryServices: [],
    comissions: [],
    commissions_change: [],
    selectedEmployees: [],
  },
  getters: {
    getSelectedEmployees: state => state.selectedEmployees,
    getServices: state => state.services,

    getCommissionsChange: state => state.commissions_change,

    getCommissions: state => state.comissions,
    getCategoryServices: state => state.categoryServices,
  },
  mutations: {
    setServices(state, services) {
      state.services = services
    },
    setCommissionsChange(state, commissions_change) {
      state.commissions_change = commissions_change
    },
    setCommissions(state, comissions) {
      state.comissions = comissions
    },
    setSelectedEmployees(state, selectedEmployees) {
      state.selectedEmployees = selectedEmployees
    },
    setCategoryServices(state, categoryServices) {
      state.categoryServices = categoryServices
    },
  },
  actions: {
    getAll(context, {
      itemsPerPage, page, search, category_service_ids, filters,
    }) {
      return axios.post(`${route}?page=${page}&items_per_page=${itemsPerPage}&search=${search}`, filters)
    },

    store(context, service) {
      return axios.post(`${route}/store`, service)
    },

    update(context, service) {
      return axios.put(`${route}/update/${service.id}`, service)
    },

    destroy(context, service) {
      return axios.delete(`${route}/destroy/${service.id}`)
    },

    getCategory(context) {
      return axios.get(`${route}/get_category`)
    },

    getTypeService(context) {
      return axios.get(`${route}/get_type_service`)
    },

    // CADASTRAR CATEGORIAS
    // carregar todas as categorias
    getCategories(context) {
      return axios.get(`${route}/category/get_categories`)
    },

    // carregar todas as categorias
    getTypes(context) {
      return axios.get(`${route}/type/get_types`)
    },

    // salva cria ou atualiza a categoria
    saveCategory(context, category) {
      return axios.post(`${route}/category/update_or_create`, category)
    },

    // delete categoria
    deleteCategory(context, categoryService) {
      return axios.delete(`${route}/category/delete/${categoryService.id}`)
    },

    // cadastrar tipo de serviço
    // carregar todas as type
    getType(context) {
      return axios.get(`${route}/type/get_types`)
    },

    // salva cria ou atualiza a type
    saveType(context, category) {
      return axios.post(`${route}/type/update_or_create`, category)
    },

    // delete type
    deleteType(context, categoryService) {
      return axios.delete(`${route}/type/delete/${categoryService.id}`)
    },

    /**
     * arquivar serviço
     */
    toAchive(context, service) {
      return axios.put(`${route}/to_achive/${service.id}`)
    },
    unarchive(context, service) {
      return axios.put(`${route}/unarchive/${service.id}`)
    },

    /**
     * arquivar categoria
     */
    toAchiveCategory(context, category) {
      return axios.delete(`${route}/category/delete/${category.id}`)
    },

    /**
     * restaurar categoria
     */
    toRestoreCategory(context, category) {
      return axios.put(`${route}/category/restore/${category.id}`)
    },

    /**
     * carrega os funcionarios com commisoes de serviço abilitada
     */
    loadEmployeesCommissions(context, service_id) {
      return axios.get(`${route}/employees_commissions/${service_id}`)
    },

    /**
     * return os funcionarios cadastrados
     */
    getEmployeeService(context, service_id) {
      return axios.post(`${route}/service_employee`, { service_id })
    },

    /**
     * exportar excel serviços
     */
    exportExcel(context, filters) {
      return axios.post(`${route}/export_excel`, filters, {
        responseType: 'blob',
      })
    },

    exportPdf(context, filters) {
      return axios.post(`${route}/export_pdf`, filters, {
        responseType: 'blob',
      })
    },
  },
}
